import Controller from '@ember/controller';
import { action } from '@ember/object';
import RouterService from '@ember/routing/router-service';
import { inject as service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import AccountService from 'cio/services/account';
import AnalyticsService from 'cio/services/analytics';
import AuthService from 'cio/services/auth';
import BillingService from 'cio/services/billing';

export default class PlansAndBillingController extends Controller {
  @service billing!: BillingService;
  @service router!: RouterService;
  @service auth!: AuthService;
  @service analytics!: AnalyticsService;
  @service account!: AccountService;

  @tracked suspended = this.account.current?.accountState === 'suspended';
  @tracked reactivated = false;

  get currentRoute() {
    return this.router.currentRouteName;
  }

  get isCheckoutRoute() {
    return this.currentRoute === 'settings.billing.checkout';
  }

  get isAvailablePlansRoute() {
    return this.currentRoute.indexOf('settings.billing.available-plans') === 0;
  }

  @action
  hideSuspensionAndUpdateCard() {
    this.suspended = false;
    if (this.billing.billingInfo?.activeSubscription === true || this.billing.subscription?.active === true) {
      this.router.transitionTo('settings.billing.payment-methods');
    } else {
      this.router.transitionTo('settings.billing.checkout');
    }
  }

  @action
  trackComparePlansViewed() {
    this.analytics.track('onboarding', 'pricing_card_button_clicked', { type: 'compare plans' });
  }
}

declare module '@ember/controller' {
  interface Registry {
    'settings.billing': PlansAndBillingController;
  }
}
